import type { PickTicketsQuerySchema } from '../schemas';

export const fieldNames: Record<keyof PickTicketsQuerySchema, { name: string; revertible: boolean }> = {
  id: { name: 'ID', revertible: false },
  pick_number: { name: 'Pick Number', revertible: false },
  client_id: { name: 'Client ID', revertible: false },
  client: { name: 'Client', revertible: false },
  contacts: { name: 'Contacts', revertible: false },
  picker_id: { name: 'Picker ID', revertible: false },
  picker: { name: 'Picker', revertible: false },
  picker_type: { name: 'Picker Type', revertible: false },
  status: { name: 'Status', revertible: true },
  delivery_method: { name: 'Delivery Method', revertible: true },
  tracking_number: { name: 'Tracking Number', revertible: true },
  remove_items: { name: 'Remove Items', revertible: true },
  why_removed: { name: 'Why Removed', revertible: true },
  why_removed_comment: { name: 'Why Removed Comment', revertible: true },
  notes: { name: 'Notes', revertible: true },
  delivery_address: { name: 'Delivery Address', revertible: false },
  attached_documents: { name: 'Attached Documents', revertible: false },
  pick_ticket_items: { name: 'Items', revertible: false },
  picked_at: { name: 'Picked At', revertible: false },
};
